import { Component, Input } from '@angular/core';

@Component({
    selector: 'loading',
    template: require('./loading.component.html'),
    preserveWhitespaces: true
})
export class LoadingComponent {
    @Input() public spinner: boolean = true;
    @Input() public paginator: boolean = false;
}
